import Vue from 'vue'

import {
  Menu,
  Progress,
  Modal,
  Icon,
  Row,
  Col,
  Button,
  Layout,
  Tooltip,
  Popover,
  Spin,
  Tabs,
  List,
  Badge,
  Avatar,
  Dropdown,
  Empty,
  Table,
  Popconfirm,
  Pagination,
  message,
  notification,
  Alert,
  FormModel,
  Input,
  Space,
  Select,
  Card,
  Tag,
  Radio,
  Switch,
  Upload,
} from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'

Vue.use(Menu)
Vue.use(Progress)
Vue.use(Modal)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Button)
Vue.use(Layout)
Vue.use(Tooltip)
Vue.use(Popover)
Vue.use(Spin)
Vue.use(Tabs)
Vue.use(List)
Vue.use(Badge)
Vue.use(Avatar)
Vue.use(Dropdown)
Vue.use(Empty)
Vue.use(Table)
Vue.use(Popconfirm)
Vue.use(Pagination)
Vue.use(FormModel)
Vue.use(FormModel.Item)
Vue.use(Input)
Vue.use(Space)
Vue.use(Select)
Vue.use(Card)
Vue.use(Tag)
Vue.use(Radio)
Vue.use(Switch)
Vue.use(Upload)

Vue.prototype.$message = message
Vue.prototype.$notification = notification
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$info = Modal.info
